<template>
  <div class="animated fadeIn">
    <div v-if="!loading">
      <transition name="fade">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <div slot="header">
            <span data-font="16"> Update Service Ticket </span>
            <div class="card-header-actions">
              <eb-button
                classic="mr-1 btn-primary"
                text="Back"
                @click="$router.push('/serviceticket/open')"
              ></eb-button>
            </div>
          </div>

          <div class="mx-3 mt-2">
            <div>
              <b-row>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr" for="Number"
                        >Service Number</label
                      ></b-col
                    >
                    <b-col md="9">
                      <div class="form-group">
                        <b-form-input
                          type="text"
                          class="input-default-width"
                          placeholder="Enter the Number"
                          v-model="inputObj.number"
                          readonly
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr">Created date</label></b-col
                    >
                    <b-col md="9">
                      <div class="form-group">
                        <b-input
                          type="text"
                          class="input-default-width"
                          placeholder="created Date"
                          v-model="inputObj.createdDate"
                          readonly
                        ></b-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr mr-1" for="Customer Name">
                        Customer Name
                      </label></b-col
                    >
                    <b-col md="9">
                      <div class="form-group">
                        <b-form-input
                          type="text"
                          class="input-default-width"
                          placeholder="Enter your Name"
                          v-model="inputObj.customerName"
                          readonly
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr">Status</label></b-col
                    >
                    <b-col md="9">
                      <div class="form-group">
                        <eb-select
                          id="Status"
                          class="input-default-width"
                          label="label"
                          v-model="inputObj.status"
                          :options="ticketStatus"
                          placeholder="Select status type"
                          :selected="inputObj.status"
                        ></eb-select>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr">Customer Email</label>
                    </b-col>
                    <b-col md="9">
                      <div class="form-group">
                        <b-form-input
                          type="email"
                          class="input-default-width"
                          placeholder="Enter your Email"
                          v-model="inputObj.customerEmail"
                          readonly
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr">Category</label>
                    </b-col>
                    <b-col md="9">
                      <div class="form-group">
                        <b-form-input
                          id="issueType"
                          class="input-default-width"
                          type="text"
                          v-model="inputObj.issueType"
                          placeholder="Enter issue type"
                          readonly
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr" for="subject"
                        >Subject</label
                      ></b-col
                    >
                    <b-col md="9">
                      <div class="form-group">
                        <b-form-textarea
                          id="subject"
                          type="text"
                          placeholder="Enter the Subject."
                          v-model="inputObj.subject"
                          no-resize
                          readonly
                          style="height: 35px; width: 220px"
                        ></b-form-textarea>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="6">
                  <b-row
                    class="float-right mt-n1"
                    v-if="$currentUserData.category === 'DEALER'"
                  >
                    <b-col md="3">
                      <label class="input-label-sr">Assign To</label></b-col
                    >
                    <b-col md="9">
                      <div class="form-group">
                        <eb-select
                          type="select"
                          placeholder="All Seller"
                          label="name"
                          id="_id"
                          v-model="inputObj.assignTo"
                          :options="getsellerdata"
                          :selected="inputObj.assignTo"
                          class="input-default-width"
                        ></eb-select></div
                    ></b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr ml-n1"
                        >Customer Phone</label
                      ></b-col
                    >
                    <b-col md="9">
                      <div class="form-group">
                        <b-form-input
                          type="number"
                          class="input-default-width"
                          placeholder="Enter your Phone Number"
                          v-model="inputObj.customerPhone"
                          readonly
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="6">
                  <b-row>
                    <b-col md="3">
                      <label class="input-label-sr">Priority</label></b-col
                    >

                    <b-col>
                      <div class="form-group">
                        <eb-select
                          id="Priority"
                          type="text"
                          class="input-default-width"
                          v-model="inputObj.priority"
                          :options="priorityOptions"
                          :selected="inputObj.priority"
                          placeholder="Select priority type"
                        ></eb-select>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>

            <label class="mt-3" for="description">Description</label>
            <b-form-textarea
              id="description"
              placeholder="Enter the Description"
              v-model="inputObj.description"
              rows="3"
              max-rows="6"
              readonly
            ></b-form-textarea>
            <div v-if="inputObj.status.value == 'CLOSED'">
              <label class="mt-3" for="closingReason">Closing Reason</label>
              <b-form-textarea
                id="closingReason"
                placeholder="Enter Closing Reason"
                v-model="inputObj.closingReason"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </div>
            <label class="mt-3" for="workNoteInternal"> Note to customer</label>
            <b-form-textarea
              id="workNoteInternal"
              placeholder="Enter Work Note-Internal"
              v-model="inputObj.workNoteInternal"
              rows="3"
              maxlength="150"
              max-rows="6"
            ></b-form-textarea>
            <label class="mt-3" for="noteToCustomer">Internal Note</label>
            <b-form-textarea
              id="noteToCustomer"
              placeholder="Enter the Note to customer"
              v-model="inputObj.noteToInternalComments"
              rows="3"
              max-rows="6"
            ></b-form-textarea>

            <div
              v-if="
                Array.isArray(inputObj.workNoteHistoryList) &&
                inputObj.workNoteHistoryList.length > 0
              "
            >
              <label class="mt-3" for="workNoteHistory"
                >Note to customer history</label
              >

              <div class="mt-2">
                <b-list-group class="list-group">
                  <b-list-group-item
                    class="bs-callout bs-callout-default"
                    v-for="(item, index) in inputObj.workNoteHistoryList"
                    :key="index"
                  >
                    <div>
                      <div class="float-right">
                        <b-row>
                          <b-col>
                            <p class="float-right">
                              {{ item.updatedBy.name }} ,
                              {{ formatDateTime(item.updatedAt) }}
                            </p>
                          </b-col>
                        </b-row>
                      </div>
                      <div>
                        <h4>{{ item.updatedBy.userType }}</h4>
                        <p align="left" class="ml-1 mt-n1">
                          {{ item.description }}
                        </p>
                      </div>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
            <div
              v-if="
                Array.isArray(inputObj.noteToInternalCommentsList) &&
                inputObj.noteToInternalCommentsList.length > 0
              "
            >
              <label class="mt-3" for="workNoteHistory"
                >Internal note history</label
              >

              <div class="mt-2">
                <b-list-group class="list-group">
                  <b-list-group-item
                    class="bs-callout bs-callout-default"
                    v-for="(item, index) in inputObj.noteToInternalCommentsList"
                    :key="index"
                  >
                    <div>
                      <div class="float-right">
                        <b-row>
                          <b-col>
                            <p class="float-right">
                              {{ item.updatedBy.name }} ,
                              {{ formatDateTime(item.updatedAt) }}
                            </p>
                          </b-col>
                        </b-row>
                      </div>
                      <div>
                        <h4>{{ item.updatedBy.userType }}</h4>
                        <p align="left" class="ml-1 mt-n1">
                          {{ item.description }}
                        </p>
                      </div>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>

            <b-row class="mt-3">
              <b-col class="text-center">
                <button
                  type="button"
                  class="btn btn-primary mr-3"
                  classic="mr-1 btn-primary"
                  text="Update"
                  @click="submitTicket()"
                >
                  Update
                </button>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
export default {
  name: "CustomerTicketEdit",
  components: {
    ebSelect,
    ebButton,
  },
  data: () => {
    return {
      loading: false,

      ticketStatus: [
        { value: "OPEN", label: "OPEN" },
        { value: "CLOSED", label: "CLOSED" },
      ],
      priorityOptions: [...[...Array(11).keys()].slice(1)],
      inputObj: {
        number: "",
        createdDate: "",
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        issuedTo: "",
        priority: "",
        issueType: "",
        status: "",
        subject: "",
        closingReason: "",
        description: "",
        workNoteHistoryList: [],
        noteToInternalComments: "",
        noteToInternalCommentsList: [],
        workNoteInternal: "",
        assignTo: "",
      },
      serviceRequestData: {},
    };
  },
  computed: {
    ...mapGetters({
      getOpenServiceTicket: "serviceticket/GetOpenServiceTicket",
      getSellerList: "partner/GetPartnerList",
    }),
    getStoreServiceTicketData() {
      let ticketData = this.getOpenServiceTicket.find(
        (ticket) => ticket._id == this.$route.params.id
      );
      this.serviceRequestData = ticketData;

      this.$store.dispatch(
        "partner/fetchChildPartnersList",
        ticketData.reportedTo.id || ""
      );
      this.inputObj.number = ticketData.ticketNo;
      this.inputObj.createdDate = this.formatDateTime(ticketData.createdAt);
      this.inputObj.customerName = ticketData.reportedBy.name
        ? ticketData.reportedBy.name
        : "";
      this.inputObj.status = {
        value: ticketData.status ? ticketData.status : "",
        label: ticketData.status ? ticketData.status : "",
      };
      this.inputObj.customerEmail = ticketData.reportedBy.email
        ? ticketData.reportedBy.email
        : "";
      this.inputObj.customerPhone = ticketData.reportedBy.phone
        ? ticketData.reportedBy.phone
        : "";
      this.inputObj.assignTo =
        ticketData && ticketData.assignTo ? ticketData.assignTo.name : "";
      this.inputObj.issueType = ticketData.category.name
        ? ticketData.category.name
        : "";
      this.inputObj.priority = ticketData.priority ? ticketData.priority : "";

      this.inputObj.description = ticketData.description
        ? ticketData.description
        : "";

      this.inputObj.subject = ticketData.subject ? ticketData.subject : "";
      try {
        if (
          Array.isArray(ticketData.worknoteHistory) &&
          ticketData.worknoteHistory.length > 0
        ) {
          this.inputObj.workNoteHistoryList = ticketData.worknoteHistory.sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          );
        } else {
          this.inputObj.workNoteHistoryList = [];
        }
      } catch (err) {
        this.inputObj.workNoteHistoryList = [];
      }

      try {
        if (
          Array.isArray(ticketData.internalComments) &&
          ticketData.internalComments.length > 0
        ) {
          this.inputObj.noteToInternalCommentsList =
            ticketData.internalComments.sort(
              (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
            );
        } else {
          this.inputObj.noteToInternalCommentsList = [];
        }
      } catch (err) {
        this.inputObj.noteToInternalCommentsList = [];
      }
    },
    getsellerdata() {
      try {
        let data = this.getSellerList;
        let sellerData = [];
        if (Array.isArray(data) && data.length > 0) {
          data.map((obj) => {
            sellerData.push({
              _id: obj._id,
              name: obj.authentication.userName,
              email: obj.authentication.email,
              phone: obj.authentication.phone,
              category: obj.category,
            });
          });
          return sellerData;
        } else {
          return [];
        }
      } catch {
        return [];
      }
    },
  },
  methods: {
    async submitTicket() {
      let tenantInfo = JSON.parse(sessionStorage.getItem("userLogin"));
      let payload = {
        id: this.serviceRequestData._id,
        data: {
          category: this.serviceRequestData.category._id
            ? this.serviceRequestData.category._id
            : "",
          description: this.inputObj.description,
          priority: this.inputObj.priority,
          status: this.inputObj.status.value
            ? this.inputObj.status.value
            : this.serviceRequestData.status,
          assignTo: this.serviceRequestData.assignTo,
          updatedBy: {
            name: tenantInfo.userName,
            email: tenantInfo.email,
            id: tenantInfo._id,
            phone: tenantInfo.phone,
          },
        },
      };
      if (this.inputObj.assignTo) {
        payload.data.assignTo = {
          id: this.inputObj.assignTo._id,
          name: this.inputObj.assignTo.name,
          email: this.inputObj.assignTo.email,
          phone: this.inputObj.assignTo.phone,
          category: this.inputObj.assignTo.category,
        };
      }

      if (this.inputObj.status.value == "CLOSED") {
        payload.data.closingReason = this.inputObj.closingReason;
      } else {
      }
      let postCommentData = {
        id: this.serviceRequestData._id,
        data: {
          type: "WORKNOTE",
          comment: {
            updatedBy: {
              name: tenantInfo.userName,
              email: tenantInfo.email,
              userType: "TENANT",
              phone: tenantInfo.phone,
            },
            description: this.inputObj.workNoteInternal,
          },
        },
      };

      let internalCommentData = {
        id: this.serviceRequestData._id,
        data: {
          type: "INTERNAL",
          comment: {
            updatedBy: {
              name: tenantInfo.userName,
              email: tenantInfo.email,
              userType: "TENANT",
              phone: tenantInfo.phone,
            },
            description: this.inputObj.noteToInternalComments,
          },
        },
      };
      await this.$store
        .dispatch("serviceticket/updateServiceTicketAction", payload)
        .then(async (result) => {
          if (!this.inputObj.workNoteInternal == "") {
            await this.$store
              .dispatch(
                "serviceticket/postCommentServiceTicketAction",
                postCommentData
              )
              .then(async (result) => {
                if (!this.inputObj.noteToInternalComments == "") {
                  await this.$store
                    .dispatch(
                      "serviceticket/postCommentServiceTicketAction",
                      internalCommentData
                    )
                    .then(async (result) => {
                      this.$swal({
                        title: "Success",
                        text: "Service Ticket Updated Successfully!",
                        type: "success",
                      });
                      this.$router.push("/serviceticket/open");
                    })
                    .catch((err) => {
                      this.$swal({
                        title: "Sorry",
                        text: "Unable to Update Service Ticket",
                        type: "error",
                      });
                    });
                } else {
                  this.$swal({
                    title: "Success",
                    text: "Service Ticket Updated Successfully!",
                    type: "success",
                  });
                  this.$router.push("/serviceticket/open");
                }
              })
              .catch((err) => {
                this.$swal({
                  title: "Sorry",
                  text: "Unable to Update Service Ticket",
                  type: "error",
                });
              });
          } else {
            if (!this.inputObj.noteToInternalComments == "") {
              await this.$store
                .dispatch(
                  "serviceticket/postCommentServiceTicketAction",
                  internalCommentData
                )
                .then(async (result) => {
                  this.$swal({
                    title: "Success",
                    text: "Service Ticket Updated Successfully!",
                    type: "success",
                  });
                  this.$router.push("/serviceticket/open");
                })
                .catch((err) => {
                  this.$swal({
                    title: "Sorry",
                    text: "Unable to Update Service Ticket",
                    type: "error",
                  });
                });
            } else {
              this.$swal({
                title: "Success",
                text: "Service Ticket Updated Successfully!",
                type: "success",
              });
              this.$router.push("/serviceticket/open");
            }
          }
        })
        .catch((err) => {
          this.$swal({
            title: "Sorry",
            text: "Unable to Update Service Ticket",
            type: "error",
          });
        });
    },
    formatDateTime: function (value) {
      return moment(value).format("DD/MM/YYYY  h:mm A");
    },
    getProperTime: function (value) {
      return moment(value).format("h:mm A");
    },
  },
  async mounted() {
    this.loading = true;
    const payload = {
      id: "",
    };
    if (this.$currentUserData.category === "SELLER") {
      payload.id = this.$currentUserData._id;
    }
    await this.$store.dispatch(
      "serviceticket/openServiceTicketAction",
      payload
    );
    this.loading = false;
    this.getStoreServiceTicketData;
  },
};
</script>

<style>
[data-font="16"] {
  font-size: 16px;
}

.list-group {
  max-height: 300px;
  margin-bottom: 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.bs-callout {
  padding: 14px;
  margin: 2px 0;
  border: 1px solid #eee;
  border-left-width: 5px;
  border-radius: 3px;
  height: 86px;
}
.bs-callout-default {
  border-left-color: #898df5;
}
.bs-callout-success {
  border-left-color: #898df5;
}
h4 {
  color: #898df5;
  font-weight: bold;
}
.input-default-width {
  width: 220px;
}
.input-label-sr {
  margin-top: 15px;
}
.assign-radio-align {
  font-size: 20px;
  margin-left: 11px;
  margin-top: -2px;
  font-size: 20px;
}
</style>
